import { render } from "./AddStaffModal.vue?vue&type=template&id=1f1c10ca&scoped=true"
import script from "./AddStaffModal.vue?vue&type=script&lang=js"
export * from "./AddStaffModal.vue?vue&type=script&lang=js"

import "./AddStaffModal.vue?vue&type=style&index=0&id=1f1c10ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1c10ca"]])

export default __exports__